import React, { useState } from 'react';
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import { GoChevronRight } from "react-icons/go";
import { Button } from 'react-bootstrap';

export default function Footer() {
  const [isHovered, setIsHovered] = useState(false);

  const handleSpanClick = () => {
    // Replace "https://www.rcor.co/" with the actual external link you want to open
    window.open("https://www.rcor.co/", "_blank");
  };
  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
    
  };
  
  const textColor = "#FFFFFF"; // Set your desired text color

  const buttonStyle = {
    fontSize: "15px",
    fontWeight: 600,
    border: 'none',
    backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    color: isHovered ? 'black' : 'black',
    transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out',
  };

  return (
    <MDBFooter
      style={{ backgroundColor: "#172446" }}
      className="text-center text-lg-start text-muted"
    >
      <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
        <MDBContainer className="text-left text-md-start mt-5">
          {" "}
          {/* Set text alignment to left */}
          <MDBRow className="mt-3">
            {/* Follow Us Section */} 
            <MDBCol
              md="12"
              lg="4"
              xl="3"
              className="mx-auto mb-0"
              // className="mx-auto mb-3 text-left d-flex flex-column align-items-start justify-content-start"
              style={{ color: textColor }}
            >
              <h6 className="text-sentenceCase fw-bold mb-3"> Follow Us </h6>
              <div className="mx-auto mb-0 mt-0">
                <a
                  href="https://www.instagram.com/"
                  className="me-4 text-reset"
                >
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/Instagram.png"
                    } // Replace with the actual path to your image file
                    alt="instagram"
                    height={23} // Adjust the height as needed
                    width={23} // Adjust the width as needed
                  />
                </a>
                <a href="https://www.linkedin.com/" className="me-4 text-reset">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/Linkedin.png"} // Replace with the actual path to your image file
                    alt="linkedin"
                    height={23} // Adjust the height as needed
                    width={23} // Adjust the width as needed
                  />
                </a>
                <a href="https://www.facebook.com/" className="me-4 text-reset">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/facebook.png"} // Replace with the actual path to your image file
                    alt="Facebook"
                    height={23} // Adjust the height as needed
                    width={23} // Adjust the width as needed
                  />
                </a>
                <a href="https://www.youtube.com/" className="me-4 text-reset">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/Youtube.png"} // Replace with the actual path to your image file
                    alt="youtube"
                    height={23} // Adjust the height as needed
                    width={23} // Adjust the width as needed
                  />
                </a>
              </div>
              <div style={{ marginBottom: "1.5rem" }}>
                {/* Logo and Button Section */}
                <MDBIcon icon="gem" />
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/FooterLogo.png"}
                  height={175}
                  width={248}
                  alt=""
                  style={{ marginLeft: "-30px" }}
                />
              </div>
              <div style={{ marginTop: "1rem", marginBottom: "2rem" }}>
                <Button
                  className="mt-0 mt-md-0 mt-lg-0"
                  size="lg"
                  active
                  style={buttonStyle}
                  href="/ContactUs" // Add the desired URL here
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                >
                  &nbsp;&nbsp; Contact Us &nbsp;&nbsp;
                  <span style={{ fontSize: "20px" }}>
                    <GoChevronRight />
                  </span>
                  &nbsp;&nbsp;
                </Button>
              </div>
            </MDBCol>

            {/* Quick Links Section */}
            <MDBCol
              md="12"
              lg="4"
              xl="3"
              className="mx-auto mb-5"
              style={{ color: textColor }}
            >
              <h6 className="text-sentenceCase fw-bold mb-5"> Quick Links </h6>
              <p style={{ marginBottom: "40px" }}>
                <a href="/About" className="text-reset">
                  About
                </a>
              </p>
              <p style={{ marginBottom: "40px" }}>
                <a href="/Vacancies" className="text-reset">
                  Vacancies
                </a>
              </p>
              <p style={{ marginBottom: "40px" }}>
                <a href="/Blogs" className="text-reset">
                  Blogs
                </a>
              </p>
              <p style={{ marginBottom: "40px" }}>
                <a href="/SuccessStories" className="text-reset">
                  Success Stories
                </a>
              </p>
            </MDBCol>

            {/* Contact Section */}
            <MDBCol
              md="12"
              lg="4"
              xl="3"
              className="mx-auto mb-md-0 mb-4"
              style={{ color: textColor }}
            >
              <h6 className="text-sentenceCase fw-bold mb-5">Contact</h6>
              <p
                className="text-center mb-4"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginBottom: "40px",
                }}
              >
                <MDBIcon color="secondary" icon="phone" className="me-4">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/Call.png"}
                    alt="instagram"
                    height={15}
                    width={20}
                  />
                </MDBIcon>
                <span>
                +971 526 797 818
                  <br /> +971 526 739 811
                </span>
              </p>
              <p 
              className="text-center mb-4"
                style={{ display: "flex", alignItems: "flex-start" }}
                >
                <MDBIcon color="secondary" className="me-4">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/Mail.png"}
                    alt="instagram"
                    height={15}
                    width={20}
                  />
                </MDBIcon>
                <span>info@ascent-talents.com</span>
              </p>
              <p
                className="text-center mb-4"
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                <MDBIcon color="secondary" className="me-4">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/Location.png"}
                    alt="Location"
                    height={20}
                    width={15}
                  />
                </MDBIcon>
                <span style={{textAlign:'left'}}>
                  Ascent Talent Solutions <br />
                  LLC Licence Number: 2327528.01 <br />
                  Shams Business Center <br />
                  Sharjah Media City free Zone <br />
                  Al Messaned, Sharjah, UAE
                </span>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className="text-center p-4" style={{ color: textColor }}>
        Copyrights © 2024 Ascent Talent Solutions. All right reserved. @ Powerd 
        By {" "}
        <span
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "white",
          }}
          onClick={handleSpanClick}
        >
          <img
                    src={process.env.PUBLIC_URL + "/assets/images/Rocrlogo.png"}
                    alt="instagram"
                    height={25}
                    width={80}
                  />
          {/* RCOR Technologies Private LTD  */}
        </span>
      </div>
    </MDBFooter>
  );
}
